import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Button} from '@tickchak/react-share/app';
import EmptyCard from '../../../../component/emptyCard/EmptyCard';
import {STATIC_IMAGE} from '../../../../config/config';
import PlusThin from '../../../../assets/icons/PlusThin';
import {RootState} from '../../../../redux/store.type';

interface LecturersEmptyProps {
    search: string;
    onAdd: () => void;
}

function LecturersEmpty({search, onAdd}: LecturersEmptyProps) {
    const {t} = useTranslation('timetable');
    const noLecturers = useSelector((s: RootState) => s.timetable.lecturers.length === 0);
    const text = noLecturers
        ? {title: t('emptyLecturersTitle'), description: t('emptyLecturersDescription'), dataCy: 'empty-lecturers-add'}
        : {title: t('noResultsFor', {term: search}), description: t('tryAnotherName'), dataCy: 'lecturers-no-results-add'};

    return (
        <EmptyCard image={`${STATIC_IMAGE}/app/timetable/pageNoLectures.png`} title={text.title} description={text.description} bordered={false} compact>
            <Button variant="brand" size="chip" iconStart={<PlusThin/>} onClick={onAdd} data-cy={text.dataCy}>
                {t('addNewLecturer')}
            </Button>
        </EmptyCard>
    );
}

export default LecturersEmpty;
